import React from 'react';
import styles from './About.module.css';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet-async';

const About = () => {
    return (
        <div>
            <Helmet>
                <title>Citizens of the Internet | About</title>
            </Helmet>
            <Nav />
            <div className={styles.aboutContainer}>
                <section className={styles.about}>
                    <h1>About</h1>
                    <p>Citizens of the Internet is a personal website gallery that features unique, thoughtful and expertly-crafted personal websites from across the internet.</p>
                    <p>Approximately 5.52 billion people on Planet Earth, or 69% of the global population, use the internet. Of these users, perhaps only 1% or less have their own personal website.</p>
                    <p>This gallery is dedicated to that 1%, to the web nerds who have staked their claim to the information superhighway and built their own hypertext home.</p>
                    <p>Citizens is created and curated by <a href="https://benhatch.com" target="_blank" rel="noreferrer">Ben Hatch</a>.</p>
                </section>
            </div>
            <Footer />
        </div>
    );
};

export default About;